import { render } from "./MainLayout.vue?vue&type=template&id=0ae014ca&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=0ae014ca&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=0ae014ca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae014ca"]])

export default __exports__